module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/operator.6dad6524.svg";